import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: resolveApiUrl("/"),
    prepareHeaders: (headers) => {
      headers.set("CSRFToken", getCsrfValue());
      headers.set("Content-Type", "application/json");
      return headers;
    },
    credentials: "same-origin",
  }),
  tagTypes: ["Wishlist", "Minicart", "AsmState"],
  endpoints: () => ({}),
});
